import { FeatureFlagName } from '@common';
import { mainRestApi } from '@state/stores/restApi/rest-api';

export const featureFlagsApi = mainRestApi.injectEndpoints({
  endpoints: (build) => ({
    fetchFeatureFlagStatus: build.query<
      {
        featureFlagName: string;
        featureFlagStatus: boolean;
      }[],
      { userId?: string }
    >({
      query: ({ userId }) => ({
        url: `/feature-flags`,
        method: 'GET',
        params: { userId }
      })
    })
  })
});

export const { useFetchFeatureFlagStatusQuery } = featureFlagsApi;

export const useFlag = (flag: FeatureFlagName): boolean => {
  const { data: flags } = useFetchFeatureFlagStatusQuery({});

  return Boolean(
    (flags ?? []).find((f) => f.featureFlagName === flag)?.featureFlagStatus
  );
};

export const useFlagWithUserId = (
  flag: FeatureFlagName,
  userId: string
): boolean => {
  const { data: flags } = useFetchFeatureFlagStatusQuery({ userId });

  return Boolean(
    (flags ?? []).find((f) => f.featureFlagName === flag)?.featureFlagStatus
  );
};
